import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentListItemAddedAction = {
	type: 'DOCUMENT_LIST_ITEM_ADDED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentListItemAddedAction => ({
	type: 'DOCUMENT_LIST_ITEM_ADDED',
	payload,
});
